import React from 'react';
import { useTranslation } from 'react-i18next';
import { WizardStep } from './wizardTypes';

interface Props {
  steps: WizardStep[];
  currentStep: WizardStep;
}

const WizardProgressBar: React.FC<Props> = ({ steps, currentStep }) => {
  const { t } = useTranslation();
  const currentIndex = steps.indexOf(currentStep);

  const labelKey = (step: WizardStep) => `wizard.steps.${step}`;

  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {steps.map((step, i) => (
        <React.Fragment key={step}>
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
                i < currentIndex
                  ? 'bg-emerald-500 dark:bg-emerald-500 text-white dark:text-white'
                  : i === currentIndex
                  ? 'bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900'
                  : 'bg-zinc-200 dark:bg-zinc-700 text-zinc-500 dark:text-zinc-400'
              }`}
            >
              {i < currentIndex ? (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                i + 1
              )}
            </div>
            <span className="text-[10px] mt-1 text-muted dark:text-muted-dark hidden sm:block max-w-[80px] text-center leading-tight">
              {t(labelKey(step))}
            </span>
          </div>
          {i < steps.length - 1 && (
            <div
              className={`h-0.5 w-8 sm:w-12 mt-[-16px] sm:mt-0 transition-colors ${
                i < currentIndex ? 'bg-emerald-500' : 'bg-zinc-200 dark:bg-zinc-700'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WizardProgressBar;
